import React, { FC } from 'react';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { createRandomKey } from '../../utils/jsxUtils';
import {
  buildUrlWithParameters,
  isUrlInternal,
} from '../../utils/url-utils/urlUtils';
import { CommentaryLinkContent } from './CommentaryLinkContent';
import { Commentary } from '../commentary.types';

type Props = {
  commentary: Commentary;
  onCommentaryClicked: Function;
  source: string;
  className?: string;
  small?: boolean;
};

export const HybridCommentaryCard: FC<Props> = ({
  commentary,
  source,
  className,
  onCommentaryClicked,
  small = false,
}) => {
  const isDoctrineLink = isUrlInternal(commentary.url);
  const commentaryLink = isDoctrineLink
    ? buildUrlWithParameters(commentary.url, { source })
    : commentary.url;
  const id = `access-limited-${createRandomKey()}`;

  return (
    <Hyperlink
      data-for={id}
      data-tip
      data-offset="{'top': -20}"
      onClick={() => onCommentaryClicked(commentary)}
      href={commentaryLink}
      target={isDoctrineLink ? '' : '_blank'}
      rel={isDoctrineLink ? '' : 'nofollow'}
      className={className}
    >
      <CommentaryLinkContent
        commentary={commentary}
        isDoctrineLink={isDoctrineLink}
        small={small}
      />
      <Tooltip effect="solid" place="top" id={id}>
        <div>
          <FormattedMessage id="commentary/card/HybridCommentaryCard.tsx/1" />
        </div>
        <div>
          <FormattedMessage id="commentary/card/HybridCommentaryCard.tsx/2" />{' '}
          {commentary.sourceName}
        </div>
      </Tooltip>
    </Hyperlink>
  );
};
